import { Link } from "react-router-dom";
import { buttonVariants } from "@/components/ui/button";

export default function ApprovalMissing({ id }: { id: string }) {
  return (
    <div className="mx-auto mt-10 max-w-[520px] rounded-lg border border-line bg-surface p-6 text-center">
      <span aria-hidden className="text-2xl">🔍</span>
      <h1 className="mt-2 text-lg font-bold text-ink">Approval item not found</h1>
      <p className="mx-auto mt-1 max-w-[380px] text-[12.5px] leading-relaxed text-muted">
        No details are available for “{id}”. Only transfer approvals include an interactive detail view.
      </p>
      <div className="mt-4">
        <Link to="/approvals" className={buttonVariants({ variant: "primary" })}>
          Back to Approvals
        </Link>
      </div>
    </div>
  );
}